import { LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL, CREATE_SUB_ENTITY_TYPE_URL, UNASSIGN_SUB_ENTITY_TYPE_URL } from '@/utils/constants/constants.js';
import axios from 'axios';
import $ from 'jquery';

export default {
  methods: {
    build_available_children(assigned_child_ids, parent_id) {
      return (this.all_children || [])
        .filter((child) => Number(child.id) !== parent_id)
        .map((child) => ({
          ...child,
          entity_type_name: child.entity_type_name ?? child.name ?? 'Unnamed',
          is_assigned: assigned_child_ids.has(Number(child.id)),
          is_loading: false,
        }));
    },

    async open_assign_modal(entity_item) {
      const parent_id = Number(entity_item?.id);
      const parent_name = this.safe_obj_get(entity_item, 'Job Profile') || '';
      this.show_assign_modal = true;
      this.current_form.parent_id = parent_id;
      this.current_form.parent_name = parent_name;
      const is_empty = !Array.isArray(this.all_children) || !this.all_children.length;
      if (is_empty) await this.view_created_trust_type();
      const assigned = await this.get_assigned_children(parent_id).catch(() => []);
      const ids = new Set((assigned || []).map((c) => Number(c.child_entity_type_id)));
      this.available_children = this.build_available_children(ids, parent_id);
      this.datatable_key += 1;
      await this.$nextTick();
    },

    async get_assigned_children(parent_entity_type_id) {
      const res = await axios.get(LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL, {
        headers: this.headers,
        params: { parent_entity_type_id },
      }).catch((err) => {
        const msg = err?.response?.data?.message || err?.message || 'Failed to load assigned children.';
        this.show_error(msg);
        return { data: null };
      });
      if (!res?.data || res.data?.status !== 'success') {
        this.show_error('Could not load assigned children.');
        return [];
      }
      const payload = res.data?.data;
      this.displayed_assigned_children = payload;
      return Array.isArray(payload) ? payload : (payload?.assigned_children || []);
    },

    async assign_sub_entity(parent_id, child_id) {
      await axios.post(CREATE_SUB_ENTITY_TYPE_URL, { parent_id, child_id }, { headers: this.headers });
      return true;
    },

    async unassign_sub_entity(parent_id, child_id) {
      await axios.post(UNASSIGN_SUB_ENTITY_TYPE_URL, { parent_id, child_id }, { headers: this.headers });
      return true;
    },

    async on_toggle_assign(child, evt) {
      const target_checked = evt.target.checked;
      const parent_id = Number(this.current_form?.parent_id);
      const child_id = Number(child?.id);
      if (!parent_id || !child_id) {
        evt.target.checked = !target_checked;
        this.show_error("Missing parent or child id.");
        return;
      }
      child.is_loading = true;
      const action = target_checked ? this.assign_sub_entity : this.unassign_sub_entity;
      const success_msg = target_checked ? "Sub-Entity Type Added Successfully." : "Sub-Entity Type Removed Successfully.";
      const result = await action(parent_id, child_id).catch((err) => {
        evt.target.checked = !target_checked;
        this.show_error(this.extract_error_message(err));
        return null;
      });
      child.is_loading = false;
      if (result !== null) {
        child.is_assigned = target_checked;
        this.show_success(success_msg);
      }
    },

    init_assign_table() {
      const sel = '#assign_sub_entity_table';
      if ($.fn.DataTable.isDataTable(sel)) $(sel).DataTable().destroy();
      this.$nextTick(() => {
        this.assign_datatable = $(sel).DataTable({
          destroy: true,
          language: {
            search: 'Filter:',
            lengthMenu: 'Show _MENU_',
            info: 'Showing _START_ to _END_ of _TOTAL_',
            infoEmpty: 'No entries',
            zeroRecords: 'No matching sub-entities found',
          },
        });
      });
    },

    destroy_assign_table() {
      const sel = '#assign_sub_entity_table';
      if ($.fn.DataTable.isDataTable(sel)) $(sel).DataTable().clear().destroy();
      this.assign_datatable = null;
    },

    close_assign_modal() {
      this.show_assign_modal = false;
    },

    reinit_assign_table() {
      this.destroy_assign_table();
      this.init_assign_table();
    },

    opening_assign_modal(row) {
      this.$emit('open-assign-modal', row);
    },
  },
};
